import * as tracking from 'dibs-tracking';

const videoStarted = ({ vimeoId }) => {
    tracking.trackEvent({
        action: 'video started',
        category: 'video',
        label: vimeoId,
    });
};
const videoPlaying = ({ vimeoId, percentComplete }) => {
    tracking.trackEvent({
        action: 'video played for percentage',
        category: 'video',
        label: vimeoId,
        value: percentComplete,
    });
};

const videoFinished = ({ vimeoId }) => {
    tracking.trackEvent({
        action: 'video finished',
        category: 'video',
        label: vimeoId,
    });
};

export const videoPaused = ({ vimeoId }) => {
    tracking.trackEvent({
        action: 'video paused',
        category: 'video',
        label: vimeoId,
    });
};

export const initialTrackingState = [
    [0, false],
    [0.25, false],
    [0.5, false],
    [0.75, false],
    [0.9, false],
    [1, false],
];

export const percentCompleted = (trackingStateRef, vimeoId) => ({ percent }) => {
    trackingStateRef.current.forEach(([targetPercent, fired], index) => {
        if (!fired) {
            if (targetPercent <= percent) {
                trackingStateRef.current[index][1] = true;
                if (targetPercent === 0) {
                    videoStarted({ vimeoId });
                } else {
                    videoPlaying({ vimeoId, percentComplete: targetPercent });
                }
                // if target is 100% and both 90% is true and percent
                // is very close to 100% or 0%, count video as finished
            } else if (
                targetPercent === 1 &&
                trackingStateRef.current[4][1] &&
                (percent > 0.99 || percent <= 0.05)
            ) {
                trackingStateRef.current[index][1] = true;
                videoFinished({ vimeoId });
            }
        }
    });
};
export default {
    percentCompleted,
    videoPaused,
    initialTrackingState,
};
